// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3E-u1","paramInput":"JobSimulator_paramInput__1SJql","input":"JobSimulator_input__c9KA5"};